var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStars = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.039 5.214a3.314 3.314 0 00-.568-.154c-.121-.021-.121-.195 0-.217a3.458 3.458 0 00.568-.154A3.315 3.315 0 004.15 2.164c.022-.121.196-.121.217 0l.008.04A3.315 3.315 0 006.478 4.69a3.315 3.315 0 00.568.154c.121.022.121.196 0 .217A3.314 3.314 0 004.367 7.74c-.021.121-.195.121-.217 0a3.315 3.315 0 00-2.111-2.525zm4.054 4.312a5.384 5.384 0 00-.417-.095L5.67 9.43l-.008-.002-.052-.009-.009-.001c-.194-.037-.194-.315 0-.352l.01-.001.05-.01.009-.001.006-.001a5.946 5.946 0 00.417-.095A5.365 5.365 0 009.968 4.76l.002-.006.001-.008.01-.05v-.002l.001-.01c.037-.193.315-.193.352 0l.001.01.01.052v.008l.002.006.01.057a5.43 5.43 0 00.175.66 5.365 5.365 0 004.108 3.576h.006l.008.002.052.01.009.001c.194.037.194.315 0 .352l-.037.006-.024.004-.008.002-.006.001a5.485 5.485 0 00-.718.185 5.365 5.365 0 00-3.575 4.108l-.001.006-.002.008-.003.018-.006.033-.001.01c-.037.194-.315.194-.352 0l-.001-.01-.01-.051-.001-.008-.001-.006a5.76 5.76 0 00-.095-.418 5.362 5.362 0 00-3.78-3.78zm-2.676 3.722a2.09 2.09 0 011.667 1.687c.014.077.123.077.137 0l.005-.025a2.088 2.088 0 011.662-1.662l.025-.005c.077-.013.077-.123 0-.137a2.128 2.128 0 01-.829-.343 2.095 2.095 0 01-.863-1.349c-.014-.076-.123-.076-.137 0a2.088 2.088 0 01-1.692 1.692c-.077.014-.077.124 0 .137l.025.005z"
  })));
};
export default SvgStars;